<template>
  <div>
    <div class="top-sticky">
      <a-menu v-model="current" mode="horizontal">
        <a-menu-item key="helpdeskCategory" @click="goTo('helpdeskCategory')">
          Category
        </a-menu-item>
        <a-menu-item key="helpdeskGroup" @click="goTo('helpdeskGroup')">
          Group</a-menu-item
        >
      </a-menu>
    </div>

    <router-view></router-view>
  </div>
</template>
<script>
export default {
  data() {
    return {
      current: [this.$route.name],
    };
  },
  methods: {
    goTo(name) {
      this.$router.push({ name });
    },
  },
};
</script>
<style scoped>
div.top-sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 1;
  /* box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1); */
  /* border-bottom: 1px solid #ddd; */
}
</style>
